import { faCheck, faWarning } from '@fortawesome/pro-light-svg-icons'
import { productTypesInversed } from '@teinor/erp/types/company/product'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { checkIfUniqueNumberAndIsProcessed, checkUniqueNumberComplete } from '../../../../../../../utils/globals/product/uniqueNumber'
import { useCallback } from 'react'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'

export interface OrderUniqueNumberProductProps extends OrderUniqueNumberProductLogicProps {
    readOnlyFnc?: (allRowData: RowData) => boolean
}

const OrderUniqueNumberProduct: React.FC<OrderUniqueNumberProductProps> = ({ allRowData, setOpenModal, warehouses, readOnlyFnc }) => {
    const { myOpenModal } = useOrderUniqueNumberProductLogic({ allRowData, setOpenModal, warehouses })
    const productType = allRowData['productType']
    const isSerializedOrLot = productType === productTypesInversed['lots'] || productType === productTypesInversed['serialized']
    const readOnly = readOnlyFnc?.(allRowData) || false
    if (checkIfUniqueNumberAndIsProcessed(allRowData)) {
        return allRowData.unique_number
    }
    if (!isSerializedOrLot) {
        return null
    }
    if (allRowData.processed || readOnly) {
        return <OrderUniqueNumberProductReadOnly setOpenModal={setOpenModal} allRowData={allRowData}/>
    }
    const isComplete = checkUniqueNumberComplete(allRowData)
    return (
        <div onClick={myOpenModal} className={'hover:text-green-43 cursor-pointer flex items-center ' + (isComplete ? 'text-green-43' : 'text-red-BA')}>
            <TwinIcon className='mr-5' icon={isComplete ? faCheck : faWarning} />
            <span><TwinTrans transKey='configure'>Configurar</TwinTrans></span>
        </div>
    )
}

interface OrderUniqueNumberProductLogicProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    allRowData: RowData
    warehouses: TwinDictionary
}

const useOrderUniqueNumberProductLogic = ({ allRowData, setOpenModal, warehouses }: OrderUniqueNumberProductLogicProps) => {
    const myOpenModal = useCallback(() => {
        allRowData['Warehouses'] = warehouses
        setOpenModal({ allRowData, type: 'uniqueNumber' })
    }, [setOpenModal, allRowData, warehouses])
    return { myOpenModal }
}

export interface OrderUniqueNumberProductReadOnlyProps extends OrderUniqueNumberProductReadOnlyLogicProps { }

export const OrderUniqueNumberProductReadOnly: React.FC<OrderUniqueNumberProductReadOnlyProps> = ({ allRowData, setOpenModal }) => {
    const { myOpenModal } = useOrderUniqueNumberProductReadOnlyLogic({ allRowData, setOpenModal })
    const productType = allRowData['productType']
    const isSerializedOrLot = productType === productTypesInversed['lots'] || productType === productTypesInversed['serialized']
    if (checkIfUniqueNumberAndIsProcessed(allRowData)) {
        return allRowData.unique_number.serialCode
    }
    if (!isSerializedOrLot) {
        return null
    }
    return (
        <div onClick={myOpenModal} className='hover:text-green-43 cursor-pointer flex items-center text-green-43'>
            <span><TwinTrans transKey='show'>Mostrar</TwinTrans></span>
        </div>
    )
}

interface OrderUniqueNumberProductReadOnlyLogicProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    allRowData: RowData
}

const useOrderUniqueNumberProductReadOnlyLogic = ({ allRowData, setOpenModal }: OrderUniqueNumberProductReadOnlyLogicProps) => {
    const myOpenModal = useCallback(() => {
        allRowData['readOnly'] = true
        setOpenModal({ allRowData, type: 'uniqueNumber' })
    }, [setOpenModal, allRowData])
    return { myOpenModal }
}

export default OrderUniqueNumberProduct